import React, { createContext, useContext, useState, useEffect } from 'react';
import QueryFormModal from './QueryFormModal';

const QuoteContext = createContext(null);

export const useQuote = () => useContext(QuoteContext);

export const QuoteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [defaults, setDefaults] = useState({ title: 'Get a Quote', subtitle: 'Share a few details and our team will reach out within 24 hours.', service: '' });
  const [unlocked, setUnlocked] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem('dc10g_pricing_unlocked') === '1') setUnlocked(true);
    } catch (e) {}
  }, []);

  const openQuote = (opts = {}) => {
    setDefaults({
      title: opts.title || 'Get a Quote',
      subtitle: opts.subtitle || 'Share a few details and our team will reach out within 24 hours.',
      service: opts.service || ''
    });
    setOpen(true);
  };

  const handleSuccess = () => setUnlocked(true);

  return (
    <QuoteContext.Provider value={{ openQuote, unlocked, setUnlocked }}>
      {children}
      <QueryFormModal
        open={open}
        onClose={() => setOpen(false)}
        onSuccess={handleSuccess}
        title={defaults.title}
        subtitle={defaults.subtitle}
        defaultService={defaults.service}
      />
    </QuoteContext.Provider>
  );
};
